<div class="common-modal__container-feedback">
  <!-- Cabecera -->
  @if(configuration.typeModal === 'rich'){
    <div [class]="adviceModal.classHeader">
      <i [class]="adviceModal.iconHeader + ' common-status-message__icon-xl'"></i>
        <span class="common-status-message__jt-title">{{configuration.titleText}}</span>
    </div>
  }@else {
    <div [class]="adviceModal.classHeader">
      <i [class]="adviceModal.iconHeader + ' common-status-message__icon-xl'"></i>
    </div>
  }
  <!-- Contenedor -->
  @if (configuration.text) {
    <div class="common-modal__content-header-feedback-info"
      [ngClass]="{'common-modal__content-header-feedback-info--center': configuration.typeModal !== 'rich',
        'gap-[8px]': adviceModal.typeText === 'normal' && configuration.secondText }">
      @if (adviceModal.typeText === 'normal') {
        <span [innerHTML]="configuration.text"></span>
        @if (configuration.secondText) {
          <span [innerHTML]="configuration.secondText"></span>
        }
      }@else if (adviceModal.typeText === 'link') {
        <span>
          <span [innerHTML]="adviceModal.firstQuestionText"></span>
          <button class="common-button__link"
            (click)="openInfoModal()">
            <span class="common-button__link-text">{{adviceModal.buttonLink}}</span>
          </button>
          <span [innerHTML]="adviceModal.lastQuestionText"></span>
        </span>
      }
    </div>
  }
  @if(configuration.list?.length){
    @switch (configuration.typeList) {
      @case('oauth'){
        <div class="advice-modal__container-list">
          <div class="common-modal__content-scroll">
            @for (item of configuration.list; track $index) {
              <div class="advice-modal__item-list">
                <div class="advice-modal__item-list-header">
                  <div class="advice-modal__inner-item-list-header">
                    <span class="advice-modal__item-list-title">{{item.title}}</span>
                    <span class="advice-modal__item-list-subtitle">({{item.oauthUser}})</span>
                  </div>
                </div>
                <div class="advice-modal__item-list-info">
                  <span class="advice-modal__item-list-info-text">-{{item.breadcrumb}}</span>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @case ('list-title-with-border') {
        <div class="advice-modal__container-list">
          <div class="common-modal__content-scroll">
            <div class="advice-modal__item-list">
              <div class="advice-modal__item-list-header">
                <div class="advice-modal__inner-item-list-header">
                  <span class="advice-modal__item-list-title">{{configuration.listTitle}}</span>
                </div>
              </div>
              <div class="advice-modal__item-list-info">
                @for (item of configuration.list; track $index) {
                  <span class="advice-modal__item-list-info-text">-{{item.text}}</span>
                }
              </div>
            </div>
          </div>
        </div>
      }
      @case ('header-info-list'){
        <div class="advice-modal__container-list">
          <div class="advice-modal__list-with-title-container">
            <div class="advice-modal__list-with-title-header">
              <i [class]="configuration.listIcon+ ' common-icon__md'"></i>
              <p class="advice-modal__item-list-title">{{configuration.listTitle}}</p>
            </div>
            <div class="advice-modal__list-with-title-list">
              @for (item of configuration.list; track $index) {
                <div class="common-modal__item-list-link">
                  <button class="common-button__link">
                    <a class="common-button__link-text" [href]="'mailto:'+item.email">- {{item.email}}</a>
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @case('error-concepts') {
        <div class="common-import-modal__errors-container">
          <div class="common-import-modal__errors-header">
            <span
              [afTranslate]="'users-admin.import.error-concepts'"
              class="common-import-modal__errors-title">
              _Fichas con errores de validación
            </span>
            <div class="common-badge__badge-block">
              <span class="common-badge__square-md">
                {{configuration.list.length}}
              </span>
            </div>
          </div>
          <ul class="common-import-modal__errors-list">
            @for (item of configuration.list; track $index) {
              @for (error of item.errorList; track $index) {
                <li class="common-import-modal__errors-list-item">
                  <i class="lf-icon-build common-icon__md common-import-modal__analized-total-icon">
                  </i>
                  <div class="common-import-modal__errors-list-item-text">
                    <span class="w-[80px]">
                      {{item.nameComplete}}
                    </span>
                    <span>
                      {{error.errorType}}: {{error.errorDescription}}
                    </span>
                  </div>
                </li>
              }
            }
          </ul>
        </div>
      }
      @case('list-with-links'){
        <div class="common-modal__content-header-feedback-info"
        [ngClass]="{'common-modal__content-header-feedback-info--center': configuration.typeModal !== 'rich'}">
        @for (item of configuration.list; track $index) {
          <div class="advice-modal__item-list-info-text">
            <span class="common-button__link"
              [innerHTML]="item.text">
            </span>
          </div>
        }
      </div>
      }
      @default {
        <div class="common-modal__content-header-feedback-info"
          [ngClass]="{'common-modal__content-header-feedback-info--center': configuration.typeModal !== 'rich'}">
          @for (item of configuration.list; track $index) {
            <span class="advice-modal__item-list-info-text">
              - {{item.text}}
            </span>
          }
        </div>
      }
    }
  }
  @if(configuration.footerText){
    <div class="common-modal__content-header-feedback-info">
      <span [innerHTML]="configuration.footerText"></span>
    </div>
  }
  <!-- </div> -->
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    @switch (configuration.typeButtons) {
      @case ('question') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="isLanding ? 'common.cancel' : 'common.no'">No</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="isLanding ? 'common.ok-button' : 'common.yes'">Si</span>
        </button>
      }
      @case ('continue') {
        <button class="common-button__text-border"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.exit'">Salir</span>
        </button>
        <button class="common-button__text"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.continue'">Continuar</span>
        </button>
      }
      @case ('onlyContinue') {
        <button class="common-button__text"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.continue'">Continuar</span>
        </button>
      }
      @case ('remain') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.remain'">Permanecer</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.exit'">_Salir</span>
        </button>
      }
      @case ('finish') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.return'">Volver</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.finish'">Finalizar</span>
        </button>
      }
       @case ('finishCancel') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.finish'">Finalizar</span>
        </button>
      }
      @case ('exitAll') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('without-save')">
          <span class="common-button__text-title" [afTranslate]="'common.discard-all-and-exit'">Descartar todo y salir</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('save-all')">
          <span class="common-button__text-title" [afTranslate]="'common.save-all-and-exit'">Guardar todo y salir</span>
        </button>
      }
      @case ('exitUniqueConcept') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('discard-navegate')">
          <span class="common-button__text-title" [afTranslate]="'common.discard-navegate'">Descartar y navegar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('save-navegate')">
          <span class="common-button__text-title" [afTranslate]="'common.save-navegate'">Guardar y navegar</span>
        </button>
      }
      @case ('accept') {
        <button class="common-button__text"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.ok'">Aceptar</span>
        </button>
      }
      @case ('cancelContinue') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('continue')">
          <span class="common-button__text-title" [afTranslate]="'common.continue'">Continuar</span>
        </button>
      }
       @case ('cancelSave') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('save')">
          <span class="common-button__text-title" [afTranslate]="'common.save'">Guardar</span>
        </button>
      }
      @case ('acceptContinue') {
        <button class="common-button__text"
          (click)="handleAccept('continue')">
          <span class="common-button__text-title" [afTranslate]="'common.ok'">Aceptar</span>
        </button>
      }
      @case ('saveContinue') {
        <button class="common-button__text-noborder"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text-border"
          (click)="handleAccept('without-save')">
          <span class="common-button__text-title" [afTranslate]="'common.continue-without-save'">Continuar sin guardar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('save-and-continue')">
          <span class="common-button__text-title" [afTranslate]="'common.save'">Guardar</span>
        </button>
      }
      @case ('seeAll') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'landing-page.create-new-query'">Crear nueva consulta</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'landing-page.see-all-queries'">Ver todas mis consultas</span>
        </button>
      }
      @case ('onlySaveContinueAndCancel') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('save-and-continue')">
          <span class="common-button__text-title" [afTranslate]="'common.save-and-continue'">Guardar y continuar</span>
        </button>
      }
      @case ('deleteOption') {
        <button class="common-button__text-noborder"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text-border"
          (click)="handleAccept('send-to-trash')">
          <span class="common-button__text-title" [afTranslate]="'common.send-to-trash'">Enviar a papelera</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('permanently-delete')">
          <span class="common-button__text-title" [afTranslate]="'common.remove'">Eliminar</span>
        </button>
      }
      @case ('cancelRemove') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.remove'">Eliminar</span>
        </button>
      }
      @case ('questionDeleteClient') {
        <button class="common-button__text-noborder"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text-border"
          (click)="handleAccept('discard-processes')">
          <span class="common-button__text-title" [afTranslate]="'common.discard-processes'">Descartar proceso</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('remove')">
          <span class="common-button__text-title" [afTranslate]="'common.permanently-delete'">_Eliminar definitivamente</span>
        </button>
      }
      @case ('reset') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('continue')">
          <span class="common-button__text-title" [afTranslate]="'common.reset'">Resetear</span>
        </button>
      }
      @case ('questionRecord') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">_Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'record-audio-modal.new-record'">_Nueva grabación</span>
        </button>
      }
      @case ('deactivate') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('permanently-delete')">
          <span class="common-button__text-title" [afTranslate]="'documentation-list.unactive'">Desactivar</span>
        </button>
      }
      @case ('restore') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.restore'">Restaurar</span>
        </button>
      }
      @case ('advance') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.advance'">Avanzar</span>
        </button>
      }
      @case ('goBack') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.go-back'">Retroceder</span>
        </button>
      }
      @case ('exitEdit') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.exit'">Salir</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.edit'">Editar</span>
        </button>
      }
      @case ('hideShow') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'expanded-menu.hidden'">Ocultar</span>
        </button>
      }
      @case ('cancelArchive') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.store'">Archivar</span>
        </button>
      }
      @case ('cancelEmptyFile') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'folder.empty-file'">Vaciar archivo</span>
        </button>
      }
      @case ('cancelChange') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.change'">Cambiar</span>
        </button>
      }
      @case ('clean') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.clean'">Limpiar</span>
        </button>
      }
      @case ('lock') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'concept-form.lock'">Bloquear</span>
        </button>
      }
      @case ('unlock') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'expanded-menu.unlock'">Desbloquear</span>
        </button>
      }
      @case ('reassign') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.reassign'">Reasignar</span>
        </button>
      }
      @case ('permanently-block') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'expanded-menu.permanently-block'">Bloquear definitivamente</span>
        </button>
      }
      @case ('end-relationship') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'finish-block-modal.end-relationship'">Finalizar relación</span>
        </button>
      }
      @case ('exitRemain') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.remain'">Permanecer</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.exit'">Salir</span>
        </button>
      }
      @case ('saveMandatoryForm') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'concept-form.keep-editing'">Seguir editando</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'concept-form.save-as-draft'">Guardar como borrador</span>
        </button>
      }
      @case ('discardNotification') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">_cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'personalized-notification-modal.discard-notification'">_Descartar notificación</span>
        </button>
      }
      @case ('cancelPublish') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">_Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.publish'">_Publicar</span>
        </button>
      }
      @case ('cancelCertify') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">_Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.certify'">_Certificar</span>
        </button>
      }
      @case ('cancelDeleteBin') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'documentation-list.delete-bin'">Vaciar papelera</span>
        </button>
      }
      @case ('cancelUpdate') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.update'">Actualizar</span>
        </button>
      }
      @case ('desconveneCancel') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.desconvene'">Finalizar</span>
        </button>
      }
      @case ('cancelModify') {
        <button class="common-button__text-border"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept()">
          <span class="common-button__text-title" [afTranslate]="'common.modify'">Modificar</span>
        </button>
      }
      @case ('exitTask') {
        <button class="common-button__text-noborder"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text-border"
          (click)="handleAccept('without-save')">
          <span class="common-button__text-title" [afTranslate]="'common.continue-without-save'">Continuar sin guardar</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('save-and-share')">
          <span class="common-button__text-title" [afTranslate]="'common.save-and-share'">Guardar y compartir</span>
        </button>
      }
      @case ('discardConvert') {
        <button class="common-button__text-noborder"
          (click)="handleDismiss()">
          <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
        </button>
        <button class="common-button__text-border"
          (click)="handleAccept('discard-exit')">
          <span class="common-button__text-title" [afTranslate]="'common.discard-changes'">Descartar cambios</span>
        </button>
        <button class="common-button__text"
          (click)="handleAccept('save-exit')">
          <span class="common-button__text-title" [afTranslate]="'common.convert-in-user'">Convertir en usuario</span>
        </button>
      }
      @default {
        @if (configuration.typeButtons === 'exit' || configuration.typeButtons === 'exitTab') {
          <button class="common-button__text-noborder"
            (click)="handleDismiss()">
            <span class="common-button__text-title" [afTranslate]="'common.cancel'">Cancelar</span>
          </button>
          <button class="common-button__text-border"
            (click)="handleAccept('discard-exit')">
            <span class="common-button__text-title" [afTranslate]="'common.discard'">Descartar</span>
          </button>
          @if(configuration.typeButtons === 'exit'){
            <button class="common-button__text"
              (click)="handleAccept('save-exit')">
              <span class="common-button__text-title" [afTranslate]="'common.save'">Guardar</span>
            </button>
          }@else{
            <button class="common-button__text"
              (click)="handleAccept('save-exit-tab')">
              <span class="common-button__text-title" [afTranslate]="'common.save-exit'">Guardar y salir</span>
            </button>
          }
        }
      }
    }
  </div>
</div>
